import { Switch } from 'antd';
import React, { useEffect, useState } from 'react'
import {
    LineChart,
    Line,
    XAxis,
    YAxis,
    CartesianGrid,
    Tooltip,
    Legend,
    ResponsiveContainer,
    Area,
    ReferenceDot,
    ReferenceLine,
    Label,
    AreaChart,
    ComposedChart,
    Bar
} from "recharts";
import { Tooltip as AntdTooltip } from 'antd';
import { ChartLine, Table2, RefreshCw, RefreshCcw, Info, CalendarDays } from "lucide-react";
import { dispatchHandler, handleApiChange } from '../../../helper/apiHelperFunctions';
import { getPermissionKey } from '../../../helper/permissions';
import { useDispatch, useSelector } from 'react-redux';
import GenericInput from '../../../genericComponents/input/GenericInputComponent';
import Icons from '../../../assets/icons';
import GenericCustomButton from '../../../genericComponents/GenericCustomButton';
import { formatNumber } from '../../../helper/genericFunction';
import NoDataFound from '../../../genericComponents/NoDataFound';
import TableLoader from '../../../genericComponents/oldGenericComponents/tableHelperComponents/TableLoader';

const ForecastChart = React.memo(({ graphicalData, isMaxMin, animate }) => {

        const CustomTooltip = ({ active, payload, label }) => {
            if (active && payload && payload.length) {
                return (
            <div className="px-3 py-2 rounded-[10px] bg-white border border-[#8496A9]" style={{boxShadow: '0px 0px 6px 0px #00000033'}}>
                    {/* <div className='mb-2.5 flex items-center gap-1'>
                        <CalendarDays size={12} className='shrink-0 text-fontGrey' />
                        <p className="mt-0.5 mb-0 text-fontGrey text-[11px]">{label}</p>
                    </div> */}
                    {payload.map((entry, index) => (
                        <div className='mb-1.5 last:mb-0 flex items-center justify-between gap-7'>
                            <div className='flex items-center gap-2'>
                                <div className={`h-[11px] w-[11px] shrink-0 rounded-full`} style={{backgroundColor: entry.color}}></div>
                                <p className='mb-0 text-[13px] text-fontGrey font-medium'>{entry.name}</p> 
                            </div>
                            <p className='mb-0 font-semibold text-[13px] text-fontBlack'>{entry.value}</p>
                        </div>
                    ))}
                </div>
                );
            }

            return null;
        };

        const YAxisLabel = ({ viewBox, value }) => {
            const { x, y, width, height } = viewBox; // use viewBox instead of x/y/width/height directly
            const cx = (x + width / 2) - 10;
            const cy = y + height / 2;

            return (
                <text
                x={cx}
                y={cy}
                textAnchor="middle"
                fill="#111D31"
                fontWeight={700}
                fontSize={12}
                transform={`rotate(-90, ${cx}, ${cy})`}
                >
                {value}
                </text>
            );
        };

        return (
            <div className="w-full h-full flex items-center justify-center">
                {graphicalData?.length ? isMaxMin ?
                <ResponsiveContainer width="100%" height="100%">
                    <ComposedChart
                        data={graphicalData}
                        margin={{
                            top: 20,
                            right: 20,
                            bottom: 0,
                            left: 7,
                        }}
                    >             
                        <defs>
                            <linearGradient id="forecastGradient" x1="0" y1="0" x2="0" y2="1">
                                <stop offset="0%" stopColor="#03B67580" stopOpacity={0.8} />
                                <stop offset="100%" stopColor="#ECB80B00" stopOpacity={0} />
                            </linearGradient>
                        </defs>           

                        <CartesianGrid stroke="#EDF2F6" />
                        <XAxis dataKey="month" />
                        <YAxis
                            tickFormatter={(value) => {
                                if (value >= 1000) return formatNumber(value).short;
                                return value;
                            }}
                            label={<YAxisLabel value="QUANTITY" />} 
                        />
                        <Tooltip 
                            content={<CustomTooltip />}
                            cursor={{ stroke: '#67768E', strokeDasharray: '5 5', strokeWidth: 2 }}
                        />
                        {/* <Area type="monotone" dataKey="Forecasted" fill="#b1e1c0" stroke="#8884d8" /> */}
                        <Line dataKey="Min" stroke="#0b58cb" strokeWidth={2} isAnimationActive={animate} />
                        <Line dataKey="Max" stroke="#12b9f5" strokeWidth={2} isAnimationActive={animate} />
                        <Area 
                            // type="monotone"   
                            dataKey="Forecasted" 
                            fill="url(#forecastGradient)" 
                            stroke="#03B675" 
                            strokeWidth={2}
                            isAnimationActive={animate}
                        />
                    </ComposedChart>
                </ResponsiveContainer> :
                <ResponsiveContainer width="100%" height="100%">
                    <ComposedChart
                        data={graphicalData}
                        margin={{
                            top: 20,
                            right: 20,
                            bottom: 0,
                            left: 7,
                        }}
                    >
                         <defs>
                            <linearGradient id="forecastGradient" x1="0" y1="0" x2="0" y2="1">
                                <stop offset="0%" stopColor="#03B67580" stopOpacity={0.8} />
                                <stop offset="100%" stopColor="#ECB80B00" stopOpacity={0} />
                            </linearGradient>
                        </defs>

                        <CartesianGrid stroke="#EDF2F6" />
                        <XAxis dataKey="month" />
                        <YAxis 
                            tickFormatter={(value) => {
                                if (value >= 1000) return formatNumber(value).short;
                                return value;
                            }}
                            label={<YAxisLabel value="QUANTITY" />}
                        />
                        {/* <Tooltip /> */}
                        <Tooltip 
                            content={<CustomTooltip />}
                            cursor={{ stroke: '#67768E', strokeDasharray: '5 5', strokeWidth: 2 }}
                        />
                        {/* <Area type="monotone" dataKey="Forecasted" fill="#b1e1c0" stroke="#8884d8" /> */}
                        <Line dataKey="Actual" stroke="#0C58CB" strokeWidth={2} isAnimationActive={animate} />
                        <Line dataKey="Budgeted" stroke="#14B9F5" strokeWidth={2} strokeDasharray="5 5" isAnimationActive={animate} />
                        <Area 
                            // type="monotone"   
                            dataKey="Forecasted" 
                            fill="url(#forecastGradient)" 
                            stroke="#03B675" 
                            strokeWidth={2}
                            isAnimationActive={animate}
                        />
                    </ComposedChart>
                </ResponsiveContainer>
                : <NoDataFound/>
                }
            </div>
        );
    });


function SalesForecastDashboard(props) {

    const digiArsStore = useSelector(state => state.digiArsStore);
    const generalStore = useSelector(state => state.generalStore);

    const [isMaxMin, setIsMaxMin] = useState(false);
    const [inputData, setInputData] = useState({
        frequency: {
            frequency: "Monthly",
            key: "monthly"
        },
        viewMode: {
            icon: <ChartLine size={19} />,
            key: "graphicalView",
            viewMode: "Graphical View"
        }
    });

    const [graphicalData, setGraphicalData] = useState([])
    const [headersData, setHeadersData] = useState({});
    const [animateChart, setAnimateChart] = useState(true);

    const dispatch = useDispatch();

    useEffect(() => {
        handleApiChange(dispatch, "getHeadersRequest", {
            enterpriseName: "TURNINGCLOUD",
            displayName: 'FORECAST_DATA',
            basedOn: "main",
        });
    }, []);

    // useEffect(() => {
    //     setAnimateChart(true);
    //     const t = setTimeout(() => setAnimateChart(false), 400);
    //     return () => clearTimeout(t);
    // }, [graphicalData]);



    useEffect(() => {
        let filter = {};
        if(inputData?.site?.code) filter.site_code = inputData?.site?.code;
        if(inputData?.assortment?.assortment) filter.assortment = inputData?.assortment?.assortment;
        if(inputData?.viewMode?.key == "graphicalView") {
            let payload = {
                frequency: inputData?.frequency?.key ?? "monthly",
                filter: {
                    ...filter
                }
            }
            dispatchHandler(dispatch, "arsDashboardForecastRequest", payload, getPermissionKey("dashboard", "forecastdashboard", "view"));
        }
        else {
            let payload2 = {
                displayName: "FORECAST_DATA",
                pageNo: "1",
                pageSize: "10",
                search: "",
                filter: {
                    ...filter,
                    frequency: inputData?.frequency?.key ?? "monthly",
                }
            }
            dispatchHandler(dispatch, "arsPlanForecastDataRequest", payload2, getPermissionKey("dashboard", "forecastdashboard", "view")); // table data
        }
    }, [inputData?.viewMode?.viewMode, inputData?.frequency?.key, inputData?.site?.code, inputData?.assortment?.assortment]);

    // Function to convert the date to the desired format
    const formatDate = (dateString) => {
        const date = new Date(dateString);
        return date.toLocaleDateString('en-GB', { day: 'numeric', month: 'short' });
    }

    // Merging the data
    const mergeData = (data, poData) => {
        const mergedData = [];

        // Process data
        data.forEach(item => {
            let obj = {};
            obj = {
                "month": formatDate(item?.prediction_date),
                "Actual": item?.actual_qty || 0,
                "Budgeted": item?.budgeted_qty || 0,
                "Forecasted": item?.predicted_qty || 0,
                "Max": item?.max_qty || 0,
                "Min": item?.min_qty || 0,
            }
            mergedData.push(obj)
        });

        return mergedData;
    }

    useEffect(() => {
        if (digiArsStore?.arsDashboardForecastData?.isSuccess) {
            const result = mergeData(digiArsStore?.arsDashboardForecastData?.data);
            // setGraphicalData(result?.reverse());
            setGraphicalData([...result].reverse());
        }

        if(generalStore?.getHeadersData?.isSuccess) {
            let headersType = Object.keys(generalStore?.getHeadersData?.data?.resource?.["Custom Headers"] || {})?.length > 0 ? "Custom Headers" : "Default Headers";
            let headers = { ...generalStore?.getHeadersData?.data?.resource?.[headersType] };
            setHeadersData(headers);
        }
        if(digiArsStore?.arsPlanForecastDataData?.isSuccess) {
            setGraphicalData(digiArsStore?.arsPlanForecastDataData?.data?.resource || []);
        }
    }, [digiArsStore?.arsDashboardForecastData?.isSuccess, generalStore?.getHeadersData?.isSuccess, digiArsStore?.arsPlanForecastDataData?.isSuccess]);

    const inputFields = [
        { type: "dropdown", placeholder: "All Site", value: "", key: "site", iconRight: <Icons.DownArrowNew /> },
        { type: "dropdown", placeholder: "Assortment", value: "", key: "assortment", iconRight: <Icons.DownArrowNew /> },
        { type: "dropdown", placeholder: "Monthly", value: "", key: "frequency", iconRight: <Icons.DownArrowNew /> },
        { type: "dropdown", placeholder: "Graphical View", value: "", key: "viewMode", iconRight: <Icons.DownArrowNew />, iconLeft: <span className='mr-1'>{inputData?.viewMode?.icon ?? <ChartLine size={19} />}</span>, genInputExtraClass: 'min-w-[160px] max-w-none' },
    ]

    const getInputProps = (key) => {

        const commonProps = {
            modalMainClass: 'mt-[4px] !top-full'
        }

        switch (key) {
            case "site": {
                return ({
                    ...commonProps,
                    search: {
                        placeholder: `Search Site`,
                    },
                    viewDataType: "table-view",
                    api: {
                        reduxState: 'generalStore',
                        apiName: 'getSearchFilters',
                        apiPayload: (params) => {
                            return {
                                "entity": "site",
                                "key": "name1",
                                "code": "code",
                                "search": params?.currentSearch || "",
                                "searchBy": params.searchFilter || "CONTAINS",
                                "pageNo": params?.currentPage || 1,
                                "moduleName": "",
                                "other_data": {},
                                "columnName": {}
                            }
                        },
                        getMaxPage: (states, functions, response) => Number(response?.resource?.maxPage || ""),
                    },
                    getListData: (response) => {
                        return response?.resource?.searchResultNew?.map(data => ({ ["site"]: data["name1"], ...data }))
                    },
                    headerKeys: {
                        site: { value: ["site"] },
                    },
                    itemKeys: {
                        site: ["site"],
                    }
                })
            }
            case "assortment": {
                return ({
                    ...commonProps,
                    search: {
                        placeholder: `Search Site`,
                    },
                    viewDataType: "table-view",
                    api: {
                        reduxState: 'generalStore',
                        apiName: 'getSearchFilters',
                        apiPayload: (params) => {
                            return {
                                "entity": "generic_final_assortment",
                                "key": "assortment_name",
                                "code": "",
                                "search": params?.currentSearch || "",
                                "searchBy": params.searchFilter || "CONTAINS",
                                "pageNo": params?.currentPage || 1,
                                "moduleName": "",
                                "other_data": {},
                                "columnName": {}
                            }
                        },
                        getMaxPage: (states, functions, response) => Number(response?.resource?.maxPage || ""),
                    },
                    getListData: (response) => {
                        return response?.resource?.searchResultNew?.map(data => ({ ["assortment"]: data["assortment_name"], ...data }))
                    },
                    headerKeys: {
                        assortment: { value: ["assortment"] },
                    },
                    itemKeys: {
                        assortment: ["assortment"],
                    }
                })
            }
            case "frequency": {
                return ({
                    ...commonProps,
                    getListData: () => ([{ frequency: "Monthly", key: "monthly" }, { frequency: "Weekly", key: "weekly" }]),
                    headerKeys: {
                        frequency: {
                            value: "Name",
                        }
                    },
                    itemKeys: {
                        frequency: ["frequency"]
                    },
                })
            }
            case "viewMode": {
                return ({
                    ...commonProps,
                    getListData: (response) => {
                        return [
                            {
                                icon: <ChartLine size={19} />,
                                key: "graphicalView",
                                viewMode: "Graphical View",
                            },
                            {
                                icon: <Table2 size={19} />,
                                key: "tabularView",
                                viewMode: "Tabular View",
                            }
                        ];
                    },
                    headerKeys: {
                        "viewMode": { value: "View Type" },
                    },
                    itemKeys: {
                        viewMode: [(state, functions, data) => {
                            return (<span className="flex items-center">{data?.icon} <span className="font-medium !text-[12px] ml-[5px]">{data?.viewMode}</span></span>)
                        }]
                    },
                })
            }
        
            default:
                break;
        }
    }

    const handleChange = (type, data) => {
        switch (type) {
            case "value":
                
                break;
        
            default: {
                let updateInputData = {...inputData};
                updateInputData[type] = data
                setInputData(updateInputData);
            }
                break;
        }
    }

    const ForecastTable = () => {
        let keys = {
            prediction_date: "Date",
            max_qty: "Max Qty",
            min_qty: "Min Qty",
        }

        const getColExtra = {
            prediction_qty: <div className={`h-[11px] w-[11px] shrink-0 rounded-full bg-[#03B675]`}></div>,
            actual_qty: <div className={`h-[11px] w-[11px] shrink-0 rounded-full bg-[#0C58CB]`}></div>,
            budgeted_qty: <div className={`h-[11px] w-[11px] shrink-0 rounded-full bg-[#37C8FD]`}></div>,
            deviation: <AntdTooltip
                            overlayClassName='!p-0' 
                            overlayStyle={{ fontSize: '12px' }}
                            placement='right'
                            title='Difference between the forecasted and actual value'
                        >
                        <Info size={16} color='#67768E' />            
                    </AntdTooltip>
        }

        const getHeaderTooltip = {
            prediction_qty: 'Projected sales based on current trends & estimates',
            actual_qty: 'Sales during the selected period',
            budgeted_qty: 'Targeted sales value set during the planning phase',
        }

        console.log('isMaxMin', keys, headersData)

        return (
            <div className="table-v2 max-h-full h-auto w-full overflow-auto bg-white">
                {digiArsStore?.arsPlanForecastDataData?.isLoading ? <TableLoader className='!p-[0]'/>
                : <table className="w-full">
                    <thead className="!z-[1]">
                        <tr>
                            {Object.keys(isMaxMin ? keys : headersData || {})?.map((key, index) => (
                                <th key={index} className="">
                                    <div className='flex items-center gap-2'>
                                        <AntdTooltip
                                            overlayClassName='!p-0' 
                                            overlayStyle={{ fontSize: '12px' }}
                                            placement='right'
                                            title={getHeaderTooltip[key]}
                                        >
                                            <label className='mb-0 font-medium text-[#6A6C70]'>{headersData?.[key] || "-"}</label>
                                        </AntdTooltip>
                                        {getColExtra[key]}
                                    </div>
                                </th>
                            ))}
                        </tr>
                    </thead>
                    <tbody>
                        {graphicalData?.length ? graphicalData?.map((item, index) => (
                            <tr key={index} className='border-b border-borderSlateGrey last:border-b-0'>
                                {Object.keys(isMaxMin ? keys : headersData || {})?.map((key) =>  (
                                    <td key={key + index} className={`${key === 'max_qty' ? 'bg-[#03B6750D]' : key === 'min_qty' ? 'bg-[#5D5FEF1A]' : ''}`}>
                                        <label className='mb-0 font-medium'>{key == "prediction_date" ? formatDate(item?.[key]) : item?.[key] ?? ""}</label>
                                    </td>
                                ))}
                            </tr>
                        )) : <tr className='h-[400px]'><td colSpan={100} className='h-full'><div className='flex items-center justify-center'><NoDataFound/></div></td></tr>}
                    </tbody>
                </table>
                }
            </div>
        );
    };

    return (
        <div className='pl-[30px] pr-[15px] py-3 h-[calc(100vh-90px)] flex flex-col'>
            <div className="px-4 py-3 mb-3 bg-white rounded-[5px] flex items-center justify-between gap-8">
                <div className='flex items-center gap-3'>
                    <h1 className="mb-0 text-lg font-bold whitespace-nowrap">Sales Forecast Details</h1>
                    <div className="flex items-center gap-2">
                        <span className="text-xs font-medium text-[#111D31] whitespace-nowrap">Max - Min</span>
                        <Switch className='max-w-[30px]' style={{backgroundColor: isMaxMin ? "var(--primary-color)" : "#d9d9d9"}} checked={isMaxMin} onChange={setIsMaxMin} />
                    </div>
                </div>

                <div className="flex items-center gap-2">
                    {/* <div className="flex items-center gap-2.5 text-sm">
                        <div className='text-[11px] text-end whitespace-nowrap text-[#67768E]'>
                            <p className='mb-0 font-semibold'>Last Run</p>
                            <p className='mb-0'>25/09/25 12:50 PM</p>
                        </div>
                        <GenericCustomButton
                            type='default'
                            leftIcon={<RefreshCcw size={17} className='shrink-0' />}
                            className="dashboard-refresh-button"
                            // onClick={refreshapidata}
                        />
                    </div> */}

                    {/* separator */}
                    {/* <div className='!mx-1 h-[28px] w-[1px] shrink-0 bg-borderSlateGrey'></div> */}

                    {inputFields?.map((item) => 
                        <GenericInput 
                            genInputExtraClass={`!mb-0 !max-w-[140px] whitespace-nowrap ${item?.genInputExtraClass}`}
                            type={item?.type}
                            placeholder={item?.placeholder}
                            value={inputData?.[item?.key]?.[item?.key] || ""}
                            iconLeft={item?.iconLeft}
                            iconRight={item?.iconRight}
                            inputProps={() => getInputProps(item?.key)}
                            onChange={(data) => handleChange(item?.key, data)}
                            dependentFieldsObject={[inputData?.[item?.key]?.[item?.key]]}
                        />
                    )}
                </div>
            </div>

            {inputData?.viewMode?.key === "graphicalView" ? ( <main className="h-full">
                <div className="p-[16px] pl-0 rounded-[5px] bg-white h-full flex flex-col">
                    {/* Legend and Filters */}
                    <div className="pl-4 mb-4 flex items-center gap-5">
                        <AntdTooltip
                            overlayClassName='!p-0' 
                            overlayStyle={{ fontSize: '12px' }}
                            placement='right'
                            title={!isMaxMin && 'Sales during the selected period'}
                        >
                            <div className="flex items-center gap-2">
                                <div className={`h-[11px] w-[11px] shrink-0 rounded-full bg-[#0C58CB]`}></div>
                                <span className="text-xs font-medium">{isMaxMin ? 'Min' : 'Actual'}</span>
                            </div>
                        </AntdTooltip>
                        <AntdTooltip
                            overlayClassName='!p-0' 
                            overlayStyle={{ fontSize: '12px' }}
                            placement='right'
                            title={!isMaxMin && 'Targeted sales value set during the planning phase'}
                        >
                            <div className="flex items-center gap-2">
                                <div className={`h-[11px] w-[11px] shrink-0 rounded-full bg-[#37C8FD]`}></div>
                                <span className="text-xs font-medium">{isMaxMin ? 'Max' : 'Budgeted'}</span>
                            </div>
                        </AntdTooltip>
                        <AntdTooltip
                            overlayClassName='!p-0' 
                            overlayStyle={{ fontSize: '12px' }}
                            placement='right'
                            title={'Projected sales based on current trends & estimates'}
                        >
                            <div className="flex items-center gap-2">
                                <div className={`h-[11px] w-[11px] shrink-0 rounded-full bg-[#03B675]`}></div>
                                <span className="text-xs font-medium">Forecasted</span>
                            </div>
                        </AntdTooltip>
                    </div>
                    {/* <ForecastChart /> */}
                    <ForecastChart
                        graphicalData={graphicalData}
                        isMaxMin={isMaxMin}
                        // animate={animateChart}
                        animate={false}
                    />

                </div>
            </main>) : (
                <ForecastTable />
            )}

            {/* <ResponsiveContainer width="100%" height="100%">
                <ComposedChart
                    width={500}
                    height={400}
                    data={data}
                    margin={{
                        top: 20,
                        right: 20,
                        bottom: 20,
                        left: 20,
                    }}
                >
                    <CartesianGrid stroke="#f5f5f5" />
                    <XAxis dataKey="name" scale="band" />
                    <YAxis />
                    <Tooltip />
                    <Legend />
                    <Area type="monotone" dataKey="actual" fill="#8884d8" stroke="#8884d8" />
                    <Bar dataKey="pv" barSize={20} fill="#413ea0" />
                    <Line type="monotone" dataKey="forecasted" stroke="#ff7300" />
                    <Line type="monotone" dataKey="forecasted" stroke="red" />
                </ComposedChart>
            </ResponsiveContainer> */}

        </div>
    )
}

export default SalesForecastDashboard